import axios from 'axios'
import { MessageBox } from 'element-ui';
import {PAGE_ROUTES} from "@/utils/const";

const isNewVersion = () => {
  let url = `//${window.location.host}/version.json?t=${Date.now()}`;
  axios.get(url).then(res => {
    if (res.status === 200) {
      let gjErpVersion = res.data.version;
      let localVersion = localStorage.getItem('gj-erp-version');
      if (localVersion && localVersion != gjErpVersion) {
        localStorage.setItem('gj-erp-version', gjErpVersion);
        updateModal();
        return;
      } else {
        if(!localVersion) {
          updateModal();
        }
        localStorage.setItem('gj-erp-version', gjErpVersion);
      }
    }
  });
}

function updateModal() {
  MessageBox.alert(`请点击【立即更新】刷新当前系统使用最新版本，继续使用旧版本可能会出现系统报错哦~`, '系统更新通知',{
    confirmButtonClass: "versionModalBtn",
    confirmButtonText: '立即更新',
    type: 'warning',
    showClose: false,
  }).then(()=>{
    window.location.reload();
  })
}

export default {
  isNewVersion
}